import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Symptoms } from '../components/Symptoms';
import { Conditions } from '../components/Conditions';
import { HowItWorks } from '../components/HowItWorks';
import { About } from '../components/About';
import { Testimonials } from '../components/Testimonials';
import { Financing } from '../components/Financing';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen flex flex-col bg-background text-foreground selection:bg-primary/20" data-id="element-227">
      <Header data-id="element-228" />
      <main className="flex-grow" data-id="element-229">
        <Hero data-id="element-230" />
        <Symptoms data-id="element-231" />
        <Conditions data-id="element-232" />
        <HowItWorks data-id="element-233" />
        <About data-id="element-234" />
        <Testimonials data-id="element-235" />
        <Financing data-id="element-236" />
        <Contact data-id="element-237" />
      </main>
      <Footer data-id="element-238" />
    </div>;
}